import { racehorse360 } from "@tsg/1st-grpc-web-rh360";
import { SortOrderType } from "interfaces/SortOrder";
import { IVetHorseListPageState } from "interfaces/IVetHorseListPageState";

const base = "VET_HORSE_LIST_PAGE";
export const SET_ORDER = `${base}_SET_ORDER`;
export const SET_ORDER_BY = `${base}_SET_ORDER_BY`;
export const SET_SEARCH_QUERY = `${base}_SET_SEARCH_QUERY`;
export const SET_TRAINER_SEARCH_ITEM = `${base}_SET_TRAINER_SEARCH_ITEM`;
export const SET_VET_LIST_HORSES_REQUEST_KEY = `${base}_SET_VET_LIST_HORSES_REQUEST_KEY`;

export interface IVetHorseListPageType extends IVetHorseListPageState {
  type: string;
}

export const setOrder = (
  order: SortOrderType
): Partial<IVetHorseListPageType> => {
  return {
    type: SET_ORDER,
    order
  };
};

export const setOrderBy = (
  orderBy: string[]
): Partial<IVetHorseListPageType> => {
  return {
    type: SET_ORDER_BY,
    orderBy
  };
};

export const setSearchQuery = (
  searchQuery: string
): Partial<IVetHorseListPageType> => {
  return {
    type: SET_SEARCH_QUERY,
    searchQuery
  };
};

export const setTrainerSearchItem = (
  trainerSearchItem: racehorse360.IHorse | racehorse360.ITrainer
): Partial<IVetHorseListPageType> => {
  return {
    type: SET_TRAINER_SEARCH_ITEM,
    trainerSearchItem
  };
};

export const setVetListHorsesRequestKey = (
  vetListHorsesRequestKey: (string | object)[]
): Partial<IVetHorseListPageType> => {
  return {
    type: SET_VET_LIST_HORSES_REQUEST_KEY,
    vetListHorsesRequestKey
  };
};
